import { Button } from "@material-ui/core";
import { Box, Modal, TextField, Typography } from "@mui/material";
import { MagnifyingGlass, UserPlus } from "phosphor-react";
import { useEffect, useState } from "react";
import { fget } from "../../../API/callsAPI";
import MyTeamCollaboratorsTable from "../../MyTeamMembersPageComponents/MyTeamCollaboratorsTable";
import InviteUserModal from "../../ProjectPage/ProjectPageModals/InviteUserModal/InviteUserModal";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import accessControlsSettingsStyles from "./ManageUsersSettingsStyles";

const ManageUsersSettingsOverview = ({ projectId, projectDetails }) => {
  const classes = accessControlsSettingsStyles();
  const [usersList, setUsersList] = useState([]);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [nameSearchQuery, setNameSearchQuery] = useState("");
  const [isInviteUsersModalOpen, setIsInviteUsersModalOpen] = useState(false);

  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        // ✅ if empty, load default users
        if (!nameSearchQuery.trim()) {
          const res = await fget({
            url: `project/${projectId}/users/`,
          });
          setUsersList(res?.data?.results);
          return;
        }

        // ✅ minimum 2 chars before searching
        if (nameSearchQuery.length < 2) return;

        // ✅ debounced search
        const res = await fget({
          url: `project/${projectId}/users/?q=${nameSearchQuery}`,
        });
        setUsersList(res?.data?.results);
      } catch (error) {
        console.log(error);
      }
    }, 300); // debounce delay (ms)

    // cleanup
    return () => clearTimeout(handler);
  }, [refreshCounter, projectId, nameSearchQuery]);

  return (
    <div>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <Box className={classes.flexBetween}>
        <Typography variant="h6">Manage Collaborators</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Button
            className={classes.inviteButton}
            startIcon={<UserPlus />}
            onClick={() => setIsInviteUsersModalOpen(true)}
          >
            Invite
          </Button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              backgroundColor: "#252A38",
              borderRadius: "10px",
              width: "200px",
              padding: "0px 10px",
            }}
          >
            <MagnifyingGlass size={20} />
            <TextField
              inputProps={{
                style: {
                  color: "#606479 !important",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  color: "#fff !important",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
              size="small"
              fullWidth
              placeholder="Search in list"
              value={nameSearchQuery}
              onChange={(e) => setNameSearchQuery(e.target.value)}
            />
          </div>
        </Box>
      </Box>
      <MyTeamCollaboratorsTable
        projectUsers={usersList}
        setRefreshCounter={() => setRefreshCounter(refreshCounter + 1)}
        selectedProject={projectDetails}
        setSnackValue={setSnackValue}
      />
      <Modal
        open={isInviteUsersModalOpen}
        onClose={() => setIsInviteUsersModalOpen(false)}
        className={classes.flexCenter}
      >
        <InviteUserModal
          projectId={projectDetails?.id}
          handleRefresh={() => {
            setRefreshCounter(refreshCounter + 1);
            setIsInviteUsersModalOpen(false);
          }}
          inviteType="project"
          setSnackValue={setSnackValue}
        />
      </Modal>
    </div>
  );
};

export default ManageUsersSettingsOverview;
